import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Growl } from "primereact/growl";
import {
  Card,
  CardTitle,
  CardBody,
  CardImg,
  CardText,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup,
  Alert,
} from "reactstrap";

import Moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { Checkbox, Textbox, Select as Select1 } from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";

import bg1Image from "assets/img/bg/vehiculosRamos.jpg";
import Home from "../Home";
import LoadingScreen from "react-loading-screen";
import {
  limpiarDatosCotizacion,
  setConsultaPlaca,
  consultarCedulaFetch,
  setDatosPersona,
  listarModelosFetch,
  limpiarCatalogos,
  FetchMsg,
  FetchValidarModelo,
  listarProvinciasComparadorFetch,
} from "../../redux/actions/aCotizacion";
import {
  estaEnListaNegra,
  FetchModificarCarrito,
  limpiarDatosCarrito,
  limpiarInListaNegra,
  LimpiarListaNegra,
} from "../../redux/actions/ACarritoProductos";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import DatePicker, { registerLocale } from "react-datepicker";
import { ambienteAplicacion } from "../../constants/urls";
import Ramos from "../Ramos/Ramos";
import {
  updateSucursalSeleccionada,
  ramosFetch,
  sucursalesFetch,
} from "../../redux/actions/aRamos";

import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import { ErrorMsgConstants } from "../../constants";
import NumberFormat from 'react-number-format';
import { ramos } from "../../utils/constants";
Moment.locale("es");


class Cotizacion extends React.Component {
  constructor(props) {
    super(props);
    var today = new Date();
    var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.state = {
      placa: "",
      validate: false,
      hasPlacaError: true,
      cedula: "",
      arrayMarcas: [],
      marcaSeleccionada: undefined,
      arrayModelos: [],
      modeloSeleccionado: null,
      tipoSeleccionado: "PERSONAL", //Cambiado de undefined a PERSONAL
      hasMarcaError: true,
      hasModeloError: true,
      hasCedulaError: true,
      consultaLoading: false,
      motor: "",
      chasis: "",
      anio: "",
      hasMotorError: true,
      hasChasisError: true,
      hasAnioError: true,
      tipo: "",
      hasTipoError: false,
      arrayTipos: [],
      arrayMarcasSelect: [],
      selectedMarca: null,
      startDate: firstDayOfMonth,
      nombresCompletos: "",
      ecivilSeleccionado: undefined,
      generoSeleccionado: undefined,
      mostrarPropietarioCarritoReact: false,
      accion: "nuevo",
      checklucro: false,
      checkuber: false,
      mostrarMsgUber: false,
      validacionAnioModelo: false,
      mostrarCheckLucro: false,
      mostrarErrorTerritorio: false,
      mostrarCheckuber: false,
      hasAvaluoError: true,
      avaluo: "",
      cargandoValidarMensajes: false,
      validarEdadDesdeReact: false,
      checkSinPlaca: false,
      editarPlacaErronea: false,
      /*ES */
      codigoProductoEspecial: null,
      planSeleccionado: null,
      arrayTerritorios: [],
      arrayTerritoriosComparador: [],
      territorioSeleccionadoComparador: null
    };

    this.props.fetchRamos();
    this.props.fethSucursales();

    this.validateForm2 = this.validateForm2.bind(this);
    this.regresaResumen = this.regresaResumen.bind(this);
  }



  regresaResumen(e) {

    var search = `?id=${this.props.datosCarrito.productosCarrito.idCarrito}&paso=resumen`

    if (this.state.codigoProductoEspecial == "comparador") {

      search = `?id=${this.props.datosCarrito.productosCarrito.idCarrito}&paso=resumen&codigoProductoEspecial=comparador`

    }
    this.props.history.replace({
      pathname: `/resumen-cotizacion`,
      search: search,
    });
  }

  showWarn = (message) => {
    this.growl.show({
      sticky: true,
      severity: "info",
      summary: "Información",
      detail: message,
    });
  };
  async componentDidMount() {
    this.props.limpiarDatosListaNegra()
    console.log("DATOS COTIZACION",this.props.datosCotizacion)
    const queryParams = new URLSearchParams(this.props.location.search);

    let accion = queryParams.get('accion');
    let editarPlaca = queryParams.get('editarPlaca');

    var data = queryParams.get("data");
    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    if (codigoProductoEspecial != null) {
      //console.log("codigoProductoEspecial", codigoProductoEspecial);
      this.setState({ codigoProductoEspecial: codigoProductoEspecial });
    } else {
      //console.log("No codigoProductoEspecial");
    }
    await this.props.consultarProvincias(
      codigoProductoEspecial === "comparador" ? 'comparador' : "vehiculos",
      "001"
    )

    if (this.props.datosUsuarios.usu_tipo_usuario === "cliente" || this.props.datosUsuarios.clienteFinal) {
      this.props.updateSucursalSelecionada("001")
      await this.props.consultarProvincias(
        codigoProductoEspecial === "comparador" ? 'comparador' : "vehiculos",
        ""
      )
    }
    else if (this.props.datosUsuarios.sucursalCodCore)
      this.props.updateSucursalSelecionada(
        this.props.datosUsuarios.sucursalCodCore
      );
    // else
    //   usuarioSucursal = this.props.sucursalesStatus.sucursalSelecionadaAsesor;     

    if (editarPlaca === null) {
      this.setState({
        editarPlacaErronea: true,
      });
    }

    if (accion === null) {
      accion = "nuevo";
    }
    //console.log('accion obtenida', accion);
    this.setState({ accion: accion });
    this.props.limpiarDatos();
    this.props.limpiarCatalogos();
    if (accion === "nuevo") {
      if (data != undefined && data !== null) { //Si viene data en la URL
        this.setState(
          {
            checklucro: true,
            checkuber: true,
            mostrarCheckLucro: false,
            mostrarErrorTerritorio: false,
            mostrarCheckuber: false,
            validate: true,
          },
          () => {
            var info = JSON.parse(data);
            var datosProducto = info.datosProducto;
            let placa = datosProducto.placa;
            let avaluo = datosProducto.valor_avaluo;
            this.setState(
              {
                hasPlacaError: false,
                placa: placa,
                validacionAnioModelo: false,
                hasAvaluoError: false,
                avaluo: avaluo,
              },
              () => {
                this.validateForm();
              }
            );
          }
        );

        //;
      } else {
        this.props.limpiarCarrito();
      }
    }




    let arrayTerritorios = this.state.arrayTerritorios.slice();
    var arrayTerritoriosComparador = this.state.arrayTerritoriosComparador.slice();


    /* 
        this.props.catalogoCotizacion.territorios.forEach((element) => {
          const elemento = {
            id: element.ciuCodigoCore,
            name: element.ciuNombre,
            provCodigoCore: element.provCodigoCore,
            paiCodigoCore: element.paiCodigoCore,
          };
          arrayTerritorios.push(elemento);
        }); */

    arrayTerritoriosComparador = []


    this.props.provinciasComparador.forEach((element) => {
      const elemento = {
        id: element.provCodigoCore,
        value: element.provCodigoCore,
        name: element.label,
        label: element.label,
        provCodigoCore: element.provCodigoCore,
        //paiCodigoCore: element.paiCodigoCore,
      };
      arrayTerritoriosComparador.push(elemento);

    });
    this.setState({ arrayTerritorios: arrayTerritorios });
    this.setState({ arrayTerritoriosComparador: arrayTerritoriosComparador });


    console.log('arrayTerritoriosComparador', arrayTerritorios, arrayTerritoriosComparador)
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  validateForm = async () => {
    console.log("validate");

    let _this = this;
    const {
      validate,
      hasPlacaError,
      placa,
      accion,
      checklucro,
      checkuber,
      mostrarMsgUber,
      codigoProductoEspecial,
      territorioSeleccionadoComparador
    } = this.state;

    console.log('codigoProductoEspecial', codigoProductoEspecial)
    _this.setState({ mostrarMsgUber: false });
    if (checklucro && checkuber && territorioSeleccionadoComparador) {
      console.log("entrodatafinal");
      //console.log("validating!", this.state);

      if (validate) {
        console.log("entrovalidate");
        _this.toggleValidating(true);

        //console.log("All validated!", this.state);
        if (!hasPlacaError) {
          _this.setState({
            consultaLoading: true,
            nombresCompletos: "",
            ecivilSeleccionado: undefined,
            generoSeleccionado: undefined,
            modeloSeleccionado: null,
            motor: "",
            chasis: "",
            anio: "",
            tipoSeleccionado: "PERSONAL", //Cambiado de undefined a PERSONAL
          });

          console.log('codigoProductoEspecial', codigoProductoEspecial)
          await _this.props.onClickConsultar({
            placa: placa,
            accion: accion,
            esKilometrosPaquete:
              codigoProductoEspecial === "vehiculosKilometrosPaquete"
                ? true
                : false,
            esComparador:
              codigoProductoEspecial === "comparador"
                ? true
                : false,
          });

          //await this.llenarDatosPrima();
          this.setState({ consultaLoading: false });

          setTimeout(function () {
            if (_this.props.datosPlaca && _this.props.datosPlaca && _this.props.datosPlaca.marCodigoCore && _this.props.datosPlaca.marCodigoCore != "") {
              const objetoMarca = { value: _this.props.datosPlaca.marCodigoCore, label: _this.props.datosPlaca.marca }

              _this.setState({ selectedMarca: objetoMarca })

            }
            if (_this.props.datosPlaca && _this.props.datosPlaca.alerta) {
              _this.showWarn(_this.props.datosPlaca.alerta);
            }
          }, 3000);
        } else {
          console.log("error", this.state.hasPlacaError);
        }
      }
    } else {
      console.log("entro else");
      /*await this.props.fetchMsg("msgValidarOtrosAuto");
      this.setState({ mostrarMsgUber: true })*/
      if (!checklucro) {
        this.setState({ mostrarCheckLucro: true });
      }
      if (!territorioSeleccionadoComparador) {
        this.setState({ mostrarErrorTerritorio: true });
      }
      if (!checkuber) {
        this.setState({ mostrarCheckuber: true });
      }
    }
  };


  CotizarSinPlaca = async () => {


    const {
      accion,
      codigoProductoEspecial,
    } = this.state;
    await this.props.onClickConsultar({
      placa: 'PEND',
      accion: accion,
      esComparador:
        codigoProductoEspecial === "comparador"
          ? true
          : false,


    });
  }

  handleChangeDate = (date) => {

    // this.setState({
    //   startDate: date
    // });

    if (date) {
      this.setState({
        startDate: date,
      });
    } else {
      this.setState({
        startDate: new Date(),
      });
    }
  };

  handleChange = async (selectedOption) => {
    const cuenta = Object.keys(selectedOption).length;
    //console.log("MARCAAAA ", selectedOption, cuenta)

    // validar error de marca
    let hasErrorMarca = true;
    if (selectedOption.value && selectedOption.label && selectedOption.value !== '' && selectedOption.label !== '') hasErrorMarca = false;
    this.setState({
      hasMarcaError: hasErrorMarca,
      validate: !hasErrorMarca,
    })

    this.setState({
      selectedMarca: selectedOption,
      validacionAnioModelo: false,
    });
    this.props.limpiarCatalogos();
    this.setState({
      modeloSeleccionado: null,
    });

    if (parseInt(cuenta) > 0) {
      await this.props.listarModelos(selectedOption.value, this.state.codigoProductoEspecial == "comparador" ? true : false);

      //console.log(`Option selected:`, selectedOption);
    } else {
      this.props.limpiarCatalogos();
    }
  };
  handleChangeModelo = (selectedOption) => {
    this.setState({
      modeloSeleccionado: selectedOption,
      validacionAnioModelo: false,
    });

    //console.log(`Option selected:`, selectedOption);
  };

  onContinueCotizacion = () => {
    this.props.history.push({
      pathname: "/datos-cotizacion",
      search:
        this.state.codigoProductoEspecial != null
          ? "?codigoProductoEspecial=" + this.state.codigoProductoEspecial
          : "",
      state: { textoBreadcrumbs: this.props.location.state && this.props.location.state.textoBreadcrumbs ? this.props.location.state.textoBreadcrumbs : "" }

    });
  };

  async validateForm2(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasMarcaError,
      hasModeloError,
      hasCedulaError,
      cedula,
      marcaSeleccionada,
      modeloSeleccionado,
      hasMotorError,
      hasChasisError,
      hasAnioError,
      motor,
      anio,
      chasis,
      hasTipoError,
      tipoSeleccionado,
      selectedMarca,
      placa,
      hasNombreError,
      hasEcivilError,
      hasGeneroError,
      nombresCompletos,
      startDate,
      ecivilSeleccionado,
      generoSeleccionado,
      validacionAnioModelo,
      hasAvaluoError,
      avaluo,
      validarEdadDesdeReact,
      checklucro,
      checkuber,
      mostrarCheckLucro,
      mostrarCheckuber
    } = this.state;
    //console.log("All validated!", this.state);

    let datosPlaca = this.props.datosPlaca;
    let datosPersona = this.props.datosCotizacion.datosPersona;

    let tieneError = false;
    //Validar Año y Modelo
    let restricciones = true;
    let anioActual = new Date().getFullYear();
    let aniovehiculo =
      anio !== ""
        ? anio
        : this.props.datosCotizacion.datosPlaca.anio
          ? this.props.datosCotizacion.datosPlaca.anio
          : 0;

    if (
      Number(anioActual) - Number(aniovehiculo) >
      this.props.datosCotizacion.datosPlaca.rangoAntiguedad || Number(aniovehiculo) > Number(anioActual) + 1
    ) {
      restricciones = false;
      await this.props.fetchMsg("msgValidarAnioVigencia");
      this.setState({
        validacionAnioModelo: true,
      });
    }
    //Validar Modelo y Marca Agregado para las rectricciones
    if (restricciones === true) {
      let marcaValidar = "";
      if (selectedMarca !== undefined && selectedMarca !== null) {
        marcaValidar = selectedMarca.value;
      } else if (
        this.props.datosCotizacion.datosPlaca.marCodigoCore !== null &&
        this.props.datosCotizacion.datosPlaca.marCodigoCore !== undefined
      ) {
        marcaValidar = this.props.datosCotizacion.datosPlaca.marCodigoCore;
      }
      let modeloValidar = "";
      if (modeloSeleccionado !== undefined && modeloSeleccionado !== null) {
        modeloValidar = modeloSeleccionado.value;
      } else if (
        this.props.datosCotizacion.datosPlaca.modCodigoCore !== null &&
        this.props.datosCotizacion.datosPlaca.modCodigoCore !== undefined
      ) {
        modeloValidar = this.props.datosCotizacion.datosPlaca.modCodigoCore;
      }
      this.setState({
        cargandoValidarMensajes: true,
      });
      await this.props.fetchValidaModelo(marcaValidar, modeloValidar);
      this.setState({
        cargandoValidarMensajes: false,
      });
      if (this.props.datosCotizacion.modeloRestringido) {
        restricciones = false;
        await this.props.fetchMsg("msgValidarModeloRestringido");
        this.setState({
          validacionAnioModelo: true,
        });
      }
    }
    //Validar que ingrese check uber y lucro
    if (checklucro === false) {
      restricciones = false
      this.setState({
        mostrarCheckLucro: true,
      });
    }
    if (checkuber === false) {
      restricciones = false
      this.setState({
        mostrarCheckuber: true,
      });
    }

    console.log('cedulaRecibida', cedula)
    console.log('datos cotizadores', this.props.datosCotizacion)

    if (cedula) {
      const sucursalEncontrada = this.props.sucursales.find(sucursal => sucursal.sucCodigoCore == this.props.datosSucursales.sucursalSelecionadaAsesor).sucNombre
      const nombreProducto = this.state.codigoProductoEspecial == "comparador" ? 'AIG AUTO' : "KILÓMETROS POR PAQUETES"
      const codigoProducto = this.state.codigoProductoEspecial == "comparador" ? 6 : 4
      const datosAsesor = {

        sucursalSeleccionada: this.props.datosSucursales
          .sucursalSelecionadaAsesor,

        ambiente: ambienteAplicacion,
        emailAsesor: this.props.datosUsuarios.correo
          ? this.props.datosUsuarios.correo
          : "",
          nombreProducto: nombreProducto,
          codigoProducto:codigoProducto,
          codigoRamo: ramos.VEHICULOS.codigo,
          nombreRamo: ramos.VEHICULOS.nombre,
       // ramo: ramo
      }

      await this.props.checkInListaNegra(cedula, datosAsesor)
    }



    if (this.props.datosListaNegra.inListaNegra === false) {
      //Continuar Flujo Normal
      if (restricciones === true) {
        //---------------Codigo Antes Validaciones
        if (
          this.props.datosPlaca.mostrarMarcas &&
          this.props.datosPlaca.mostrarModelos &&
          this.props.datosPlaca.mostrarPropietario &&
          this.props.datosPlaca.mostrarAnio &&
          this.props.datosPlaca.mostrarTipo &&
          this.props.datosPlaca.mostrarAvaluo
        ) {
          //consulta normal de cédula
          if (!this.props.datosCotizacion.consultarCedulaHasError) {
            if (
              modeloSeleccionado !== null &&
              selectedMarca !== null &&
              !hasCedulaError &&
              !hasAnioError &&
              !hasTipoError &&
              !hasAvaluoError
            ) {
              const modeloObtenido = this.props.catalogosCotizacion.modelos.filter(
                (modelo) => modelo.value === modeloSeleccionado.value
              );
              this.setState({ mostrarPropietarioCarritoReact: false });
              //console.log("Error solo modelo", modeloObtenido)
              datosPlaca.modelo = modeloObtenido[0].label;
              datosPlaca.modCodigoCore = modeloSeleccionado.value;
              datosPlaca.clase = modeloObtenido[0].clase;
              datosPlaca.modCodTipoVehiculo =
                modeloObtenido[0].modCodTipoVehiculo;

              const marcaObtenida = this.props.datosPlaca.arrayMarcasSelect.filter(
                (marca) => marca.value === selectedMarca.value
              );
              //console.log("Error solo modelo", marcaObtenida)
              datosPlaca.marca = marcaObtenida[0].label;
              datosPlaca.marCodigoCore = selectedMarca.value;

              // falta el tipo

              datosPlaca.motor = motor;
              datosPlaca.chasis = chasis;
              datosPlaca.anio = anio;
              datosPlaca.tipo = tipoSeleccionado;
              datosPlaca.placa = placa.toUpperCase();
              datosPlaca.valor_avaluo =
                avaluo !== undefined && avaluo !== null ? avaluo : "18000";

              this.props.setDatosPlaca(datosPlaca);
              //falta llamado a cedula
              await this.props.consultarCedula(cedula, false, true);
              if (!this.props.datosCotizacion.consultarCedulaHasError) {
                //Validar Edades desde react
                if (
                  this.props.datosCotizacion.datosPersona.validacionesEdad &&
                  this.props.datosCotizacion.datosPersona.validacionesEdad
                    .pasoValidacionEdad === true
                ) {
                  await this.llenarDatosPrima(true);
                  if (
                    !this.props.datosCarrito.productosCarrito
                      .mostrarPropietarioCarrito
                  )
                    this.onContinueCotizacion();
                  else {
                    this.setState({
                      nombresCompletos: "",
                      ecivilSeleccionado: undefined,
                      generoSeleccionado: undefined,
                    });
                  }
                }
              } else {
                this.setState({ validarEdadDesdeReact: true });
              }
            }
          }
          //No encuentra datos para la cédula
          else {
            if (
              modeloSeleccionado !== null &&
              selectedMarca !== null &&
              !hasCedulaError &&
              !hasAnioError &&
              !hasTipoError &&
              !hasNombreError &&
              !hasEcivilError &&
              !hasGeneroError &&
              !hasAvaluoError
            ) {
              const modeloObtenido = this.props.catalogosCotizacion.modelos.filter(
                (modelo) => modelo.value === modeloSeleccionado.value
              );
              this.setState({ mostrarPropietarioCarritoReact: true });
              //console.log("Error solo modelo", modeloObtenido)
              datosPlaca.modelo = modeloObtenido[0].label;
              datosPlaca.modCodigoCore = modeloSeleccionado.value;
              datosPlaca.clase = modeloObtenido[0].clase;
              datosPlaca.modCodTipoVehiculo =
                modeloObtenido[0].modCodTipoVehiculo;
              datosPlaca.valor_avaluo = avaluo; //"18000"

              const marcaObtenida = this.props.datosPlaca.arrayMarcasSelect.filter(
                (marca) => marca.value === selectedMarca.value
              );
              //console.log("Error solo modelo", marcaObtenida)
              datosPlaca.marca = marcaObtenida[0].label;
              datosPlaca.marCodigoCore = selectedMarca.value;

              // falta el tipo

              datosPlaca.motor = motor;
              datosPlaca.chasis = chasis;
              datosPlaca.anio = anio;
              datosPlaca.tipo = tipoSeleccionado;
              datosPlaca.placa = placa.toUpperCase();

              this.props.setDatosPlaca(datosPlaca);

              datosPersona.cedula = cedula;
              datosPersona.nombre = nombresCompletos;
              let fechaNacimiento = startDate
                .toISOString()
                .slice(0, 10)
                .replace(/-/g, "/");
              const answer_array = fechaNacimiento.split("/");
              datosPersona.fechaNacimiento = `${answer_array[2]}/${answer_array[1]}/${answer_array[0]}`;
              let fechaCalculoEdad = `${answer_array[0]}-${answer_array[1]}-${answer_array[2]}`;
              //Validar que todos los campos esten completos

              if (ecivilSeleccionado && generoSeleccionado) {
                const ecivilObtenido = this.props.catalogosCotizacion.estadosCiviles.filter(
                  (ecivil) => parseInt(ecivil.id) === parseInt(ecivilSeleccionado)
                );
                //console.log("ESTADOOOOOS", this.props.datosPersonas.arrayECiviles, ecivilObtenido, ecivilSeleccionado)
                datosPersona.estadoCivil = ecivilObtenido[0].name;
                datosPersona.codigoEstadoCivil = ecivilSeleccionado;
                const generoObtenido = this.props.catalogosCotizacion.generos.filter(
                  (genero) => genero.id === generoSeleccionado
                );
                datosPersona.genero = generoObtenido[0].name;
                datosPersona.codigoGenero = generoSeleccionado;
                this.props.setDatosPersona(datosPersona);

                //Validar edad del conductor cuando stupendo no devuelve datos

                if (validarEdadDesdeReact && validarEdadDesdeReact === true) {
                  //Calcular edad de la persona ingresada
                  let hoy = new Date();
                  let cumpleanos = new Date(fechaCalculoEdad);
                  let edad = hoy.getFullYear() - cumpleanos.getFullYear();
                  let m = hoy.getMonth() - cumpleanos.getMonth();
                  if (
                    m < 0 ||
                    (m === 0 && hoy.getDate() < cumpleanos.getDate())
                  ) {
                    edad--;
                  }
                  if (
                    edad >=
                    this.props.datosCotizacion.datosPersona.validacionesEdad
                      .valorMinimoEdad &&
                    edad <=
                    this.props.datosCotizacion.datosPersona.validacionesEdad
                      .valorMaximoEdad
                  ) {
                    //Enviar los datos
                    await this.llenarDatosPrima(true);
                    if (
                      !this.props.datosCarrito.productosCarrito
                        .mostrarPropietarioCarrito &&
                      !this.props.datosCarrito.hasErrored
                    )
                      this.onContinueCotizacion();
                  }
                  //Fin Calcular edad de la persona ingresada
                }
              }
            }
          }
        } else {
          let carritoReact = false;

          if (this.props.datosPlaca.mostrarMarcas) {
            if (!hasMarcaError) {

              // obtener marca correspondiente
              let marcaObtenida = []
              // caso cuando utiliza el dropdown para Marca "Select1"
              if (marcaSeleccionada) {
                this.props.datosPlaca.arrayMarcas.forEach((marca) => {
                  if (marca.id === marcaSeleccionada) {
                    marcaObtenida.push(marca);
                  }
                })
                datosPlaca.marca = marcaObtenida[0].name;
                datosPlaca.marCodigoCore = marcaSeleccionada;
              }
              // caso cuando utiliza el dropdown para Marca "Select"
              else if (selectedMarca) {
                this.props.datosPlaca.arrayMarcas.forEach((marca) => {
                  if (marca.id === selectedMarca.value) {
                    marcaObtenida.push(marca);
                  }
                })
                datosPlaca.marca = marcaObtenida[0].name;
                datosPlaca.marCodigoCore = selectedMarca.value;
              }

              // Set datos placa
              this.props.setDatosPlaca(datosPlaca);
            } else {
              //console.log("error marcaaaaaaaaaaaaaaaa")
              tieneError = true;
            }
          }

          if (this.props.datosPlaca.mostrarModelos) {
            if (modeloSeleccionado !== null) {
              //errormodelo
              //console.log("error modelooooooooooo", modeloSeleccionado)

              const modeloObtenido = this.props.catalogosCotizacion.modelos.filter(
                (modelo) => modelo.value === modeloSeleccionado.value
              );
              datosPlaca.modelo = modeloObtenido[0].label;
              datosPlaca.modCodigoCore = modeloSeleccionado.value;
              datosPlaca.clase = modeloObtenido[0].clase;
              datosPlaca.modCodTipoVehiculo =
                modeloObtenido[0].modCodTipoVehiculo;

              this.props.setDatosPlaca(datosPlaca);
            } else {
              //console.log("error modelooooooooooo2222222222222", modeloSeleccionado)
              tieneError = true;
            }
          }
          if (this.props.datosPlaca.mostrarPropietario) {
            if (!hasCedulaError) {
              //errorpropietario
              //falta llamado a cedula
              if (this.props.datosCotizacion.consultarCedulaHasError) {
                carritoReact = true;
                datosPersona.cedula = cedula;
                datosPersona.nombre = nombresCompletos;
                let fechaNacimiento = startDate
                  .toISOString()
                  .slice(0, 10)
                  .replace(/-/g, "/");
                const answer_array = fechaNacimiento.split("/");
                datosPersona.fechaNacimiento = `${answer_array[2]}/${answer_array[1]}/${answer_array[0]}`;
                let fechaCalculoEdad = `${answer_array[0]}-${answer_array[1]}-${answer_array[2]}`;

                if (ecivilSeleccionado && generoSeleccionado) {
                  const ecivilObtenido = this.props.catalogosCotizacion.estadosCiviles.filter(
                    (ecivil) =>
                      parseInt(ecivil.id) === parseInt(ecivilSeleccionado)
                  );
                  //console.log("ESTADOOOOOS", this.props.datosPersonas.arrayECiviles, ecivilObtenido, ecivilSeleccionado)
                  datosPersona.estadoCivil = ecivilObtenido[0].name;
                  datosPersona.codigoEstadoCivil = ecivilSeleccionado;
                  const generoObtenido = this.props.catalogosCotizacion.generos.filter(
                    (genero) => genero.id === generoSeleccionado
                  );
                  datosPersona.genero = generoObtenido[0].name;
                  datosPersona.codigoGenero = generoSeleccionado;
                  this.props.setDatosPersona(datosPersona);
                } else {
                  tieneError = true;
                }
                //Validar edad del conductor cuando stupendo no devuelve datos
                if (validarEdadDesdeReact && validarEdadDesdeReact === true) {
                  //Calcular edad de la persona ingresada
                  let hoy = new Date();
                  let cumpleanos = new Date(fechaCalculoEdad);
                  let edad = hoy.getFullYear() - cumpleanos.getFullYear();
                  let m = hoy.getMonth() - cumpleanos.getMonth();
                  if (
                    m < 0 ||
                    (m === 0 && hoy.getDate() < cumpleanos.getDate())
                  ) {
                    edad--;
                  }
                  if (
                    edad >=
                    this.props.datosCotizacion.datosPersona.validacionesEdad
                      .valorMinimoEdad &&
                    edad <=
                    this.props.datosCotizacion.datosPersona.validacionesEdad
                      .valorMaximoEdad
                  ) {
                    tieneError = false;
                  } else {
                    tieneError = true;
                  }
                  //Fin Calcular edad de la persona ingresada
                }
              } else {
                await this.props.consultarCedula(cedula, false, true);
                if (this.props.datosCotizacion.consultarCedulaHasError) {
                  tieneError = true;
                  this.setState({ validarEdadDesdeReact: true });
                } else {
                  //Validar Edades desde react
                  if (
                    this.props.datosCotizacion.datosPersona.validacionesEdad &&
                    this.props.datosCotizacion.datosPersona.validacionesEdad
                      .pasoValidacionEdad === false
                  ) {
                    tieneError = true;
                  } else {
                    carritoReact = true;
                    //Validar Edades desde react cuando encuentra datos en la nueva cedula ingresada
                    this.setState({ validarEdadDesdeReact: false });
                  }
                }
              }
            } else {
              tieneError = true;
            }
          }

          if (this.props.datosPlaca.mostrarMotor) {
            if (!hasMotorError) {
              //errorMotor
              datosPlaca.motor = motor;

              this.props.setDatosPlaca(datosPlaca);
            } else {
              tieneError = true;
            }
          }

          if (this.props.datosPlaca.mostrarChasis) {
            if (!hasChasisError) {
              //errorMotor
              datosPlaca.chasis = chasis;

              this.props.setDatosPlaca(datosPlaca);
            } else {
              tieneError = true;
            }
          }

          if (this.props.datosPlaca.mostrarAnio) {
            if (!hasAnioError) {
              //errorMotor
              datosPlaca.anio = anio;

              this.props.setDatosPlaca(datosPlaca);
            } else {
              tieneError = true;
            }
          }

          if (this.props.datosPlaca.mostrarTipo) {
            if (!hasTipoError) {
              //errorMotor
              datosPlaca.tipo = tipoSeleccionado;

              this.props.setDatosPlaca(datosPlaca);
            } else {
              tieneError = true;
            }
          }

          if (this.props.datosPlaca.mostrarAvaluo) {
            if (!hasAvaluoError) {
              //errorMotor
              if (avaluo > 0) {
                datosPlaca.valor_avaluo = avaluo;
                this.props.setDatosPlaca(datosPlaca);
              } else {
                tieneError = true;
              }
            } else {
              tieneError = true;
            }
          }

          this.setState({ mostrarPropietarioCarritoReact: false });
          if (!tieneError) {
            await this.llenarDatosPrima(carritoReact);
            if (!this.props.datosCarrito.hasErrored)
              datosPlaca.mostrarPropietarioCarrito = this.onContinueCotizacion();
          }
        }

        //---------------Fin Codigo antes Validaciones
      }
    }




  }

  async llenarDatosPrima(mostrarPropietarioCarritoReact) {
    let error = false;
    const { avaluo } = this.state;

    let datosPlaca = this.props.datosCotizacion.datosPlaca;
    //console.log("formulario continuar llamdardaots ", datosPlaca)

    let reemplazarPlaca = false;
    const queryParams = new URLSearchParams(this.props.location.search);
    let editarPlaca = queryParams.get('editarPlaca');
    if (editarPlaca !== null) {
      reemplazarPlaca = true
    }


    const datosAccesorios = {
      accesorios: [],
      valorAccesorios: 0,
    };
    datosPlaca.datosAccesorios = datosAccesorios;

    if (!error) {
      delete datosPlaca.arrayMarcas;
      delete datosPlaca.marcaSeleccionada;
      delete datosPlaca.arrayModelos;
      delete datosPlaca.modeloSeleccionado;
      datosPlaca.rastreoSatelital = false;
      //datosPlaca.valorAsegurado = datosPlaca.valor_avaluo === undefined || datosPlaca.valor_avaluo === "" ? "18000" : datosPlaca.valor_avaluo;
      datosPlaca.valorAsegurado =
        datosPlaca.valor_avaluo === undefined || datosPlaca.valor_avaluo === ""
          ? avaluo !== undefined && avaluo !== null
            ? avaluo
            : "18000"
          : datosPlaca.valor_avaluo;
      datosPlaca.color = "";

      var ValorAmparosAdicionales = {
        gastosMedicos: true,
        accidentesPersonales: true,
        gastosTransporte: false,
        amparoPatrimonial: false,
        objetosOlvidados: false,
        gastosFunerarios: false,
        amparoSustituto: true,
        llaveProtegida: true,
        documentosProtegidos: true,
      };

      var ValorAmparos = {
        amparoPatrimonial: false,
        objetosOlvidados: false,
        gastosFunerarios: false,
        gastosTransporteAsegurado: false,
      }

      if (this.state.codigoProductoEspecial === "comparador") {
        ValorAmparosAdicionales.amparoPatrimonial = false
        ValorAmparosAdicionales.objetosOlvidados = false
        ValorAmparosAdicionales.gastosFunerarios = false
        ValorAmparosAdicionales.gastosTransporteAsegurado = false
      }
      datosPlaca.amparos = ValorAmparosAdicionales;

      this.props.setDatosPlaca(datosPlaca);

      let datosPersona = this.props.datosCotizacion.datosPersona;
      datosPersona.codigoTerritorio = "1";
      datosPersona.provCodigoCore = "9";
      datosPersona.paiCodigoCore = "1";
      //cambiar
      // datosPersona.codigoGenero="1";

      //Verificar si el auto tiene capacidad en caso de no tenerla se crea en blanco para que el usuario pueda establecer en la siguiente pantalla
      if (datosPlaca.capacidad === undefined) {
        datosPlaca.capacidad = "";
      }

      this.props.setDatosPersona(datosPersona);



      console.log('datosSycursa', this.props.datosSucursales

        .sucursalSelecionadaAsesor, this.props.sucursales)

      const sucursalEncontrada = this.props.sucursales.find(sucursal => sucursal.sucCodigoCore == this.props.datosSucursales.sucursalSelecionadaAsesor).sucNombre

      var datosClienteAux = this.props.datosCotizacion.datosPersona;


      const territorioEncontrado2 = this.state.arrayTerritoriosComparador.find(terr => terr.value == this.state.territorioSeleccionadoComparador.value)
      datosClienteAux.codigoTerritorio = territorioEncontrado2.provCodigoCore





      var datosCarrito = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        cliCodigoCore: "",
        datosProducto: datosPlaca,
        datosCliente: datosClienteAux,
        datosCoberturas: [],
        datosAmparos: [],
        placa: datosPlaca.placa.toUpperCase(),
        accion: "agregar",
        editar: false,
        carCodigo:
          this.state.accion === "nuevo" || this.state.accion === undefined
            ? ""
            : this.props.datosCarrito.productosCarrito.idCarrito,
        mostrarPropietarioCarritoReact: mostrarPropietarioCarritoReact,


        datosAsesor: {
          nombre: `${this.props.datosUsuarios.nombres} ${this.props.datosUsuarios.apellidos}`,
          codigoCore: this.props.datosUsuarios.cliCodigoCore,
          sucursalSeleccionada: this.props.datosSucursales
            .sucursalSelecionadaAsesor,
          sucursalSeleccionadaNombre: sucursalEncontrada,
          ambiente: ambienteAplicacion,
          emailAsesor: this.props.datosUsuarios.correo
            ? this.props.datosUsuarios.correo
            : "",
          brokerRUC: this.props.datosUsuarios.brokerRUC
            ? this.props.datosUsuarios.brokerRUC
            : "",
          brokerNombre: this.props.datosUsuarios.brokerNombre
            ? this.props.datosUsuarios.brokerNombre
            : "",
          brokerCodigo: this.props.datosUsuarios.brokerCodigo
            ? this.props.datosUsuarios.brokerCodigo
            : "",
        },
        esCotizacion: false,
        amparosAdicionales: ValorAmparosAdicionales,
        codigoProductoEspecial: this.state.codigoProductoEspecial,
        plan: "",
        canal: this.props.canal != null ? this.props.canal : "",
        editarPlacaErronea: reemplazarPlaca
      };


      if (this.state.codigoProductoEspecial === "comparador") {
        datosCarrito.amparos = ValorAmparos
      }
      await this.props.modificarCarrito(datosCarrito).then((response) => {
        console.log("await", response);
      });

    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.datosPlaca !== this.props.datosPlaca) {
      if (this.props.datosPlaca.marcaSeleccionada !== undefined) {
        //console.log("Actualizando ", this.props.datosPlaca.marcaSeleccionada)
        this.setState({
          marcaSeleccionada: this.props.datosPlaca.marcaSeleccionada,
        });
      }
    }
  }

  handleOnClick() { }

  render() {

    const {
      validate,
      placa,
      cedula,
      marcaSeleccionada,
      modeloSeleccionado,
      consultaLoading,
      motor,
      chasis,
      anio,
      tipoSeleccionado,
      selectedMarca,
      nombresCompletos,
      ecivilSeleccionado,
      generoSeleccionado,
      checklucro,
      checkuber,
      mostrarMsgUber,
      validacionAnioModelo,
      mostrarCheckLucro,
      mostrarErrorTerritorio,
      mostrarCheckuber,
      avaluo,
      hasAvaluoError,
      cargandoValidarMensajes,
      checkSinPlaca,
      editarPlacaErronea
    } = this.state;

    let consultarPlacaIsLoading = !this.props.datosCotizacion
      ? false
      : this.props.datosCotizacion.consultarPlacaIsLoading;
    let consultarCedulaIsLoading = !this.props.datosCotizacion
      ? false
      : this.props.datosCotizacion.consultarCedulaIsLoading;
    let listarModelosIsLoading = !this.props.catalogosCotizacion
      ? false
      : this.props.catalogosCotizacion.listarModelosIsLoading;
    let mostrarModelos = !this.props.datosPlaca
      ? false
      : this.props.datosPlaca.mostrarModelos;
    let mostrarMarcas = !this.props.datosPlaca
      ? false
      : this.props.datosPlaca.mostrarMarcas;
    let mostrarAnio = !this.props.datosPlaca
      ? false
      : this.props.datosPlaca.mostrarAnio;
    let mostrarMotor = !this.props.datosPlaca
      ? false
      : this.props.datosPlaca.mostrarMotor;
    let mostrarChasis = !this.props.datosPlaca
      ? false
      : this.props.datosPlaca.mostrarChasis;
    let mostrarTipo = !this.props.datosPlaca
      ? false
      : this.props.datosPlaca.mostrarTipo;
    let mostrarAvaluo = !this.props.datosPlaca
      ? false
      : this.props.datosPlaca.mostrarAvaluo;

    let mostrarPropietario = !this.props.datosPlaca
      ? false
      : this.props.datosPlaca.mostrarPropietario;
    let arrayMarcas = !this.props.datosPlaca
      ? []
      : !this.props.datosPlaca.arrayMarcas
        ? []
        : this.props.datosPlaca.arrayMarcas;
    let arrayModelos = !this.props.catalogosCotizacion
      ? []
      : this.props.catalogosCotizacion.undefined
        ? []
        : this.props.catalogosCotizacion.modelos;

    let arrayTipos = !this.props.datosPlaca
      ? []
      : this.props.datosPlaca.arrayTipos;
    let carritoIsLoading = !this.props.datosCarrito
      ? true
      : this.props.datosCarrito.isLoading;
    let arrayMarcasSelect = !this.props.datosPlaca
      ? true
      : this.props.datosPlaca.arrayMarcasSelect;

    let arrayGeneros = !this.props.catalogosCotizacion
      ? []
      : !this.props.catalogosCotizacion.generos
        ? []
        : this.props.catalogosCotizacion.generos;
    let arrayECiviles = !this.props.catalogosCotizacion
      ? []
      : !this.props.catalogosCotizacion.estadosCiviles
        ? []
        : this.props.catalogosCotizacion.estadosCiviles;

    let arraySucursales = [];
    arraySucursales.push({ id: "", name: "Selecciona una sucursal" });
    this.props.sucursales.map((s) => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });

    const usuarioSucursal = this.props.sucursalesStatus
      .sucursalSelecionadaAsesor;

    //console.log(this.state, arraySucursales)    


    return (
      <LoadingScreen
        loading={
          consultarPlacaIsLoading ||
          carritoIsLoading ||
          consultarCedulaIsLoading ||
          listarModelosIsLoading ||
          cargandoValidarMensajes || this.props.datosListaNegra.listaNegraLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Obteniendo datos..."
      >
        <Page title={this.state.codigoProductoEspecial == "comparador" ? "AIG Auto" : "Cotización de vehículos"}
          breadcrumbs={[{ name: this.state.codigoProductoEspecial == "comparador" ? "AIG Auto" : "Cotización de vehículos", active: true }]}
        >
          <div class="container-step">
            <div class="wrapper-step">
              <div class="arrow-steps clearfix-step">
                <div class="step current"> {` 1. Cotización `} </div>
                <div class="step"> {` 2. Resumen `} </div>
                <div class="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          <Growl ref={(el) => (this.growl = el)} style={{ top: "100px" }} />
          <Row>
            <Col md={12} sm={12} xs={12} className="mb-3">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className="mb-5">
                    {" "}
                    Datos del Vehículo
                  </h4>
                  <Row>
                    <Col md={9} sm={12} xs={12} className="mb-3">


                      {editarPlacaErronea &&
                        <Row>
                          <Col md={6}>
                            <h5><Label for="SelectCiudad" className="bold-font-label" >¿Desea cotizar sin ingresar la placa?</Label></h5>
                          </Col>
                          <Col md={6} sm={12} xs={12} className="mb-3">
                            <Col md={12} sm={12} xs={12}>
                              <Checkbox
                                id={"checkSinPlaca"} // Optional.[String].Default: "".  Input ID.
                                name={"checkSinPlaca"} // Optional.[String].Default: "". Input name
                                value={checkSinPlaca} // Required.[String].Default: "".
                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                checked={checkSinPlaca} // Required.[Bool].Default: false.
                                classNameInputBox={'check-uber'}
                                onChange={(checkSinPlaca, e) => {
                                  this.setState({
                                    checkSinPlaca,
                                  });
                                  if (checkSinPlaca) {
                                    this.CotizarSinPlaca();
                                  }
                                  else {
                                    this.props.limpiarDatos();
                                  }

                                  //console.log(e);
                                }} // Required.[Func].Default: () => {}. Will return the value.
                              />
                            </Col>
                          </Col>
                        </Row>

                      }


                      {checkSinPlaca === false &&

                        <Row>
                          <Col md={6}>
                            <h5>
                              <Label
                                for="exampleSelect"
                                className="bold-font-label"
                              >
                                Ingrese Placa/ RAMV{" "}
                              </Label>
                            </h5>
                          </Col>
                          <Col md={6} sm={12} xs={12} className="mb-3">
                            <Col md={12} sm={12} xs={12}>
                              <Textbox
                                tabIndex="1"
                                type="input"
                                value={placa}
                                name="placa"
                                id="placa"
                                placeholder="Ingrese su placa / ramv Ej: PBA0123 / B9999111199"
                                classNameInput={"form-control"}
                                onChange={(placa, e) => {
                                  //console.log(e, e.key)
                                  this.props.limpiarDatos();
                                  this.setState({
                                    placa: placa.toUpperCase().trim(),
                                    validacionAnioModelo: false,
                                  });
                                  //this.props.limpiarDatos();
                                  //handleChangeCorreo(e)
                                }}
                                validate={validate}
                                validationCallback={(res) => {
                                  this.setState({
                                    hasPlacaError: res,
                                    validate: !res,
                                  });
                                }} // Optional.[Func].Default: none. Return the validation result.
                                onBlur={(e) => {
                                  this.setState({ blur: true });
                                  //console.log("BLUUUR");
                                }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                validationOption={
                                  this.state.placa.length > 0
                                    ? {
                                      name: "placa", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                      check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                      required: true,
                                      reg: /^[0-9a-zA-Z]+$/, //Optional.[Bool].Default: "" Custom regex.
                                      msgOnError:
                                        "La placa / ramv ingresada no debe contener espacios en blanco, símbolos o caracteres especiales. Ej: PBA0123 / B9999111199.", // Optional.[Bool].Default: true. To determin if it is a required field.
                                    }
                                    : {
                                      name: "placa", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                      check: false, // Optional.[Bool].Default: true. To determin if you need to validate.
                                      required: false,
                                      reg: /^[0-9a-zA-Z]+$/, //Optional.[Bool].Default: "" Custom regex.
                                      msgOnError:
                                        "La placa / ramv ingresada no debe contener espacios en blanco, símbolos o caracteres especiales. Ej: PBA0123 / B9999111199.", // Optional.[Bool].Default: true. To determin if it is a required field.
                                    }
                                }
                                onKeyUp={(e) =>
                                  e.key === "Enter" ? this.validateForm() : null
                                }
                              />
                            </Col>
                          </Col>
                        </Row>



                      }


                      {this.props.datosUsuarios.usu_tipo_usuario !==
                        undefined && this.props.datosUsuarios.usu_tipo_usuario !==
                        "cliente" && (
                          <Row>
                            <Col md={6}>
                              <h5>
                                <Label
                                  for="SelectCiudad"
                                  className="bold-font-label"
                                >
                                  Sucursal de emisión{" "}
                                </Label>
                              </h5>
                            </Col>
                            <Col md={6}>
                              <Col md={12}>
                                <Select1
                                  tabIndex="6" // Optional.[String or Number].Default: none.
                                  id={"SelectCiudad"} // Optional.[String].Default: "". Input ID.
                                  name={"SelectCiudad"} // Optional.[String].Default: "". Input name.
                                  value={usuarioSucursal} // Optional.[String].Default: "".
                                  optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
                                  onChange={(selec, e) => {

                                    console.log('sdasd', selec)
                                    //console.log(selec);
                                    this.props.updateSucursalSelecionada(selec);
                                    this.props.consultarProvincias(
                                      this.state.codigoProductoEspecial == "comparador" ? 'comparador' : "vehiculos",
                                      selec
                                    )
                                  }}
                                  validate={validate}
                                  validationCallback={(res) =>
                                    //console.log(res)
                                    this.setState({
                                      hasCiudadError: res,
                                      validate: !res,
                                    })
                                  }
                                  // Optional.[Func].Default: () => {}. Will return the value.
                                  onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                  customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                  validationOption={{
                                    name: "SelectCiudad", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                    msgOnError:
                                      "Por favor seleccione una sucursal",
                                  }}
                                />
                              </Col>
                            </Col>
                          </Row>
                        )}

                      {this.props.datosUsuarios.usu_tipo_usuario !==
                        undefined && this.props.datosUsuarios.usu_tipo_usuario !==
                        "cliente" && (
                          <Row>
                            <Col md={6}>
                              <h5>
                                <Label
                                  for="SelectCiudad"
                                  className="bold-font-label"
                                >
                                  Territorio de mayor circulación del vehículo{" "}
                                </Label>
                              </h5>
                            </Col>
                            <Col md={6}>
                              <Col md={12}>
                                <Select
                                  tabIndex="6" // Optional.[String or Number].Default: none.
                                  id={"selectTerritorios"} // Optional.[String].Default: "". Input ID.
                                  name={"selectTerritorios"} // Optional.[String].Default: "". Input name.
                                  isSearchable={true}
                                  value={this.state.territorioSeleccionadoComparador} // Optional.[String].Default: "".
                                  options={this.state.arrayTerritoriosComparador} // Required.[Array of Object(s)].Default: [].
                                  placeholder={'Seleccione un territorio'}
                                  onChange={(territorioSeleccionado, e) => {
                                    this.setState({
                                      territorioSeleccionadoComparador: territorioSeleccionado,
                                      formEditado: true,
                                      mostrarErrorTerritorio: false
                                    });

                                    //console.log(e);
                                  }} // Optional.[Func].Default: () => {}. Will return the value.
                                  onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                  customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                  validationOption={{
                                    name: "selectTerritorios", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                    msgOnError: "Por favor seleccione un territorio",
                                  }}
                                />
                                {mostrarErrorTerritorio && (
                                  <span style={{ color: "red", fontSize: "1rem" }}>
                                    Por favor seleccione un territorio
                                  </span>
                                )}
                              </Col>
                            </Col>


                          </Row>
                        )}


                      <Row>

                        <Col md={6}>
                          <h5>
                            <Label
                              for="SelectCiudad"
                              className="bold-font-label"
                            >
                              El auto NO es utilizado para fines de carga,
                              comercio o lucro.
                            </Label>
                          </h5>
                        </Col>
                        <Col md={6} sm={12} xs={12} className="mb-3">
                          <Col md={12} sm={12} xs={12}>
                            <Checkbox
                              id={"checklucro"} // Optional.[String].Default: "".  Input ID.
                              name={"checklucro"} // Optional.[String].Default: "". Input name
                              value={checklucro} // Required.[String].Default: "".
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              checked={checklucro} // Required.[Bool].Default: false.
                              classNameInputBox={"check-uber"}
                              onChange={(checklucro, e) => {
                                this.setState({
                                  checklucro,
                                  mostrarCheckLucro: false,
                                });
                                //console.log(e);
                              }} // Required.[Func].Default: () => {}. Will return the value.
                            />
                            {mostrarCheckLucro && (
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                Por favor marque esta opción para continuar
                              </span>
                            )}
                          </Col>
                        </Col>

                      </Row>


                      <Row>
                        <Col md={6}>
                          <h5>
                            <Label
                              for="SelectCiudad"
                              className="bold-font-label"
                            >
                              El auto NO es Uber o similares.
                            </Label>
                          </h5>
                        </Col>
                        <Col md={6} sm={12} xs={12} className="mb-3">
                          <Col md={12} sm={12} xs={12}>
                            <Checkbox
                              id={"checkuber"} // Optional.[String].Default: "".  Input ID.
                              name={"checkuber"} // Optional.[String].Default: "". Input name
                              value={checkuber} // Required.[String].Default: "".
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              checked={checkuber} // Required.[Bool].Default: false.
                              classNameInputBox={"check-uber"}
                              onChange={(checkuber, e) => {
                                this.setState({
                                  checkuber,
                                  mostrarCheckuber: false,
                                });
                                //console.log(e);
                              }} // Required.[Func].Default: () => {}. Will return the value.
                            />
                            {mostrarCheckuber && (
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                Por favor marque esta opción para continuar
                              </span>
                            )}
                          </Col>
                        </Col>
                      </Row>




                      {checkSinPlaca === true && <Row>
                        <Col md={6} sm={12} xs={12}>
                          <div class="alert alert-primary" role="alert">
                            La cotización generada desde PORTAL aplica para nuevos negocios, de ser aceptada la oferta AIG valida los datos del vehículo y/o asegurado como parte del proceso de emisión.
                          </div>
                        </Col>
                      </Row>}


                    </Col>
                    <Col md={3} sm={12} xs={12}>

                      {checkSinPlaca === false &&
                        <Button onClick={this.validateForm} className="btn btn-primary" >
                          <i class="fa fa-chevron-circle-right" aria-hidden="true" />{` CONSULTAR`}
                        </Button>
                      }


                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} sm={12} xs={12}>
                      {this.props.datosCotizacion.datosPlaca
                        .mostrarMensajeRestriccion && (
                          <Alert
                            color="warning"
                            isOpen={this.state.visibleAlert}
                            toggle={this.onDismiss}
                          >
                            <center>
                              <p>
                                {this.props.datosCotizacion.datosPlaca
                                  .MensajeRestriccion
                                  ? this.props.datosCotizacion.datosPlaca
                                    .MensajeRestriccion
                                  : ""}
                              </p>
                            </center>
                          </Alert>
                        )}
                      {mostrarMsgUber && (
                        <Alert
                          color="warning"
                          isOpen={this.state.visibleAlert}
                          toggle={this.onDismiss}
                        >
                          <center>
                            <p>
                              {this.props.datosCotizacion.textoMsg
                                ? this.props.datosCotizacion.textoMsg
                                : ""}
                            </p>
                          </center>
                        </Alert>
                      )}
                    </Col>
                  </Row>

                  {this.props.datosCotizacion.consultarPlacaHasError && checkSinPlaca === false && (
                    <Alert color="warning">
                      <center>
                        <p>
                          {
                            //this.props.datosCotizacion.datosPlaca.errorDescripcion
                            "Los datos (Placa o documento de identificación) del vehículo solicitado no se encuentra registrado."
                          }
                        </p>
                      </center>
                    </Alert>
                  )}

                  {this.props.datosCarrito.hasErrored && (
                    <Alert color="warning">
                      <center>
                        <p>
                          {"Error en el servicio. Por favor intente más tarde"}
                        </p>
                      </center>
                    </Alert>
                  )}

                  {this.props.datosCotizacion.tienePolizaPlaca && (
                    <Alert color="danger">
                      <center>
                        <p>
                          {
                            this.props.datosCotizacion.mensajeErrorPolizaPlaca
                          }
                        </p>
                      </center>
                    </Alert>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          {(mostrarModelos || mostrarMarcas || mostrarPropietario) && (
            <Row>
              <Col md={12} sm={12} xs={12} className="mb-3">
                <h4 style={{ fontWeight: "bold" }}>
                  {" "}
                  {` Por favor complete la siguiente información`}{" "}
                </h4>
              </Col>
            </Row>
          )}

          {(
            !this.props.datosCotizacion.datosPlaca
              .mostrarMensajeRestriccion &&
            (mostrarModelos ||
              mostrarMarcas ||
              mostrarAnio ||
              mostrarMotor ||
              mostrarChasis ||
              mostrarTipo ||
              mostrarAvaluo)) && (
              <Row>
                <Col md={12} sm={12} xs={12} className="mb-3">
                  <Card className="flex-row ">
                    <CardBody>
                      <h4 style={{ fontWeight: "bold" }}> Datos del Vehículo</h4>
                      <p />
                      {!mostrarMarcas && mostrarModelos && (
                        <Alert color="info">
                          <center>
                            <p>
                              {"Hemos encontrado la marca de su vehículo "}
                              <strong>
                                {this.props.datosCotizacion.datosPlaca.marca
                                  ? this.props.datosCotizacion.datosPlaca.marca
                                  : ""}
                              </strong>
                              {
                                ". A continuación por favor seleccione el modelo correcto para continuar con su cotización."
                              }
                            </p>
                          </center>
                        </Alert>
                      )}
                      {mostrarMarcas && (
                        <Row>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Marca</h5>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <Col md={12} sm={12} xs={12}>
                              {arrayMarcas.length === 1 && (
                                <Select1
                                  tabIndex="6" // Optional.[String or Number].Default: none.
                                  id={"selectMarcas"} // Optional.[String].Default: "". Input ID.
                                  name={"selectMarcas"} // Optional.[String].Default: "". Input name.
                                  value={marcaSeleccionada} // Optional.[String].Default: "".
                                  optionList={arrayMarcas} // Required.[Array of Object(s)].Default: [].
                                  onChange={(marcaSeleccionada, e) => {
                                    //console.log("seleccip ", marcaSeleccionada);
                                    this.setState({ marcaSeleccionada });
                                    //console.log(e);
                                  }} // Optional.[Func].Default: () => {}. Will return the value.
                                  onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                  customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                  validate={validate}
                                  validationCallback={(res) =>
                                    this.setState({
                                      hasMarcaError: res,
                                      validate: !res,
                                    })
                                  }
                                  validationOption={{
                                    name: "selectMarcas", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                    msgOnError: "Por favor seleccione una marca",
                                  }}
                                />
                              )}

                              {arrayMarcas.length > 1 && (
                                <Select
                                  value={selectedMarca}
                                  components={makeAnimated()}
                                  onChange={this.handleChange}
                                  options={arrayMarcasSelect}
                                  isSearchable={true}
                                  placeholder={
                                    "Seleccione la marca de su vehículo. Ej: KIA"
                                  }
                                  isMulti={false}
                                />
                              )}
                              {(selectedMarca === null ||
                                selectedMarca.length === 0) &&
                                arrayMarcas.length > 1 && (
                                  <span
                                    style={{ color: "red", fontSize: "1rem" }}
                                  >
                                    Por favor ingrese la marca
                                  </span>
                                )}
                            </Col>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={12} />
                        </Row>
                      )}

                      {mostrarModelos && (
                        <Row>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <h5 style={{ fontWeight: "bold" }}>Modelo</h5>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={12}>
                            <Col md={12} sm={12} xs={12}>
                              <Select
                                value={modeloSeleccionado}
                                components={makeAnimated()}
                                onChange={this.handleChangeModelo}
                                options={arrayModelos}
                                isSearchable={true}
                                placeholder={
                                  "Seleccione el modelo de su vehículo. Ej: SPORTAGE"
                                }
                                isMulti={false}
                              />
                              {(modeloSeleccionado === null ||
                                modeloSeleccionado.length === 0) &&
                                arrayModelos.length > 1 && (
                                  <span
                                    style={{ color: "red", fontSize: "1rem" }}
                                  >
                                    Por favor ingrese el modelo
                                  </span>
                                )}
                            </Col>
                          </Col>
                          <Col lg={4} md={4} sm={4} xs={12} />
                        </Row>
                      )}
                      {mostrarMotor && (
                        <Row>
                          <Col md={4} sm={12} xs={12} className="mb-3">
                            <h5 style={{ fontWeight: "bold" }}>
                              Serie del motor
                            </h5>
                          </Col>
                          <Col md={4} sm={12} xs={12} className="mb-3">
                            <Col md={12} sm={12} xs={12}>
                              <Textbox
                                tabIndex="1"
                                type="input"
                                value={motor}
                                name="motor"
                                id="motor"
                                placeholder="Ingrese la serie del motor"
                                classNameInput={"form-control"}
                                onChange={(motor, e) => {
                                  this.setState({ motor: motor });
                                  //this.props.limpiarDatos();
                                  //handleChangeCorreo(e)
                                }}
                                validate={validate}
                                validationCallback={(res) =>
                                  //console.log(res)
                                  this.setState({
                                    hasMotorError: res,
                                    validate: !res,
                                  })
                                } // Optional.[Func].Default: none. Return the validation result.
                                onBlur={(e) => {
                                  this.setState({ blur: true });
                                  //console.log("BLUUUR");
                                }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                validationOption={{
                                  name: "motor", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                  check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                  required: true,
                                  msgOnError:
                                    "Por favor ingrese la serie del motor", // Optional.[Bool].Default: true. To determin if it is a required field.
                                }}
                              />
                            </Col>
                          </Col>
                        </Row>
                      )}
                      {mostrarChasis && (
                        <Row>
                          <Col md={4} sm={12} xs={12} className="mb-3">
                            <h5 style={{ fontWeight: "bold" }}>
                              Serie del chasis
                            </h5>
                          </Col>
                          <Col md={4} sm={12} xs={12} className="mb-3">
                            <Col md={12} sm={12} xs={12}>
                              <Textbox
                                tabIndex="1"
                                type="input"
                                value={chasis}
                                name="chasis"
                                id="chasis"
                                placeholder="Ingrese la serie del chasis"
                                classNameInput={"form-control"}
                                onChange={(chasis, e) => {
                                  this.setState({ chasis: chasis });
                                  //this.props.limpiarDatos();
                                  //handleChangeCorreo(e)
                                }}
                                validate={validate}
                                validationCallback={(res) =>
                                  //console.log(res)
                                  this.setState({
                                    hasChasisError: res,
                                    validate: false,
                                  })
                                } // Optional.[Func].Default: none. Return the validation result.
                                onBlur={(e) => {
                                  this.setState({ blur: true });
                                  //console.log("BLUUUR");
                                }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                validationOption={{
                                  name: "chasis", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                  check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                  required: true,
                                  msgOnError:
                                    "Por favor ingrese la serie del chasis", // Optional.[Bool].Default: true. To determin if it is a required field.
                                }}
                              />
                            </Col>
                          </Col>
                        </Row>
                      )}
                      {mostrarAnio && (
                        <Row>
                          <Col md={4} sm={12} xs={12} className="mb-3">
                            <h5 style={{ fontWeight: "bold" }}>
                              Año de fabricación
                            </h5>
                          </Col>
                          <Col md={4} sm={12} xs={12} className="mb-3">
                            <Col md={12} sm={12} xs={12}>
                              <Textbox
                                tabIndex="1"
                                type="number"
                                value={anio}
                                name="anio"
                                id="anio"
                                placeholder="Ingrese el año de fabricación"
                                classNameInput={"form-control"}
                                onChange={(anio, e) => {
                                  this.setState({
                                    anio: Number(anio).toString(),
                                    validacionAnioModelo: false,
                                  });
                                  //this.props.limpiarMsg();
                                  //handleChangeCorreo(e)
                                }}
                                validate={validate}
                                validationCallback={(res) =>
                                  //console.log(res)
                                  this.setState({
                                    hasAnioError: res,
                                    validate: false,
                                  })
                                } // Optional.[Func].Default: none. Return the validation result.
                                onBlur={(e) => {
                                  this.setState({ blur: true });
                                  //console.log("BLUUUR");
                                }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                validationOption={{
                                  name: "anio", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                  check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                  required: true,
                                  msgOnError:
                                    "Por favor ingrese solo valores numéricos",
                                  customFunc: (anio) => {
                                    const reg = /[0-9]*/;
                                    if (reg.test(String(anio).toLowerCase())) {
                                      return true;
                                    } else {
                                      return "Por favor ingrese solo valores numéricos";
                                    }
                                  }, // Optional.[Bool].Default: true. To determin if it is a required field.
                                }}
                              />
                            </Col>
                          </Col>
                        </Row>
                      )}
                      {mostrarTipo && (
                        <div style={{ display: "none" }}>
                          <Row>
                            <Col md={4} sm={12} xs={12} className="mb-3">
                              <h5 style={{ fontWeight: "bold" }}>
                                Uso del vehículo
                              </h5>
                            </Col>
                            <Col md={4} sm={12} xs={12} className="mb-3">
                              <Col md={12} sm={12} xs={12}>
                                <Select1
                                  tabIndex="6" // Optional.[String or Number].Default: none.
                                  id={"selectTipos"} // Optional.[String].Default: "". Input ID.
                                  name={"selectTipos"} // Optional.[String].Default: "". Input name.
                                  value={tipoSeleccionado} // Optional.[String].Default: "".
                                  optionList={arrayTipos} // Required.[Array of Object(s)].Default: [].
                                  onChange={(tipoSeleccionado, e) => {
                                    this.setState({ tipoSeleccionado });
                                    //console.log(e);
                                  }} // Optional.[Func].Default: () => {}. Will return the value.
                                  validate={validate}
                                  validationCallback={(res) =>
                                    //console.log(res)
                                    this.setState({
                                      hasTipoError: res,
                                      validate: false,
                                    })
                                  }
                                  onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                  customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                  validationOption={{
                                    name: "selectTipos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                    msgOnError:
                                      "Por favor seleccione el uso de su vehículo",
                                  }}
                                />
                              </Col>
                            </Col>
                          </Row>
                        </div>
                      )}

                      {mostrarAvaluo && (
                        <Row>
                          <Col md={4} sm={12} xs={12} className="mb-3">
                            <h5 style={{ fontWeight: "bold" }}>Avalúo</h5>
                          </Col>
                          <Col md={4} sm={12} xs={12} className="mb-3">
                            <Col md={12} sm={12} xs={12}>

                              <NumberFormat
                                className="form-control"
                                disabled={false}
                                value={avaluo}
                                thousandSeparator={','}
                                decimalSeparator={'.'}
                                decimalScale={2}
                                prefix={''}
                                onValueChange={(valor, e) => {


                                  const error = !(valor.floatValue >= this.props.limitesVehiculos.limAvaluo.valMin && valor.floatValue <= this.props.limitesVehiculos.limAvaluo.valMax)

                                  console.log('errorRest', error)



                                  this.setState({
                                    avaluo: valor.floatValue,
                                    hasAvaluoError: error

                                  });


                                }}

                              />
                              {/*    <Textbox
                                tabIndex="1"
                                type="input"
                                value={avaluo}
                                name="avaluo"
                                id="avaluo"
                                placeholder="Ingrese Valor de Avalúo de su auto, ejemplo ($ 18000.30) "
                                classNameInput={"form-control"}
                                onChange={(avaluo, e) => {
                                  this.setState({ avaluo: avaluo });
                                }}
                                validate={validate}
                                validationCallback={(res) =>
                                  //console.log(res)
                                  this.setState({
                                    hasAvaluoError: res,
                                    validate: !res,
                                  })
                                } // Optional.[Func].Default: none. Return the validation result.
                                onBlur={(e) => {
                                  this.setState({ blur: true });
                                  //console.log("BLUUUR");
                                }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                validationOption={{
                                  type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                  min: 1, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                  max: 120000,
                                  msgOnError:
                                  " ",
                                  require: true
                                }}
                              /> */}




                            {hasAvaluoError && parseFloat(avaluo) > this.props.limitesVehiculos.limAvaluo.valMax && (
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                Se permite asegurar vehículos de hasta ${this.props.limitesVehiculos.limAvaluo.valMax}
                              </span>
                            )}

                            {hasAvaluoError && parseFloat(avaluo) < this.props.limitesVehiculos.limAvaluo.valMin && (
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                Se permite asegurar vehículos mayor a  ${this.props.limitesVehiculos.limAvaluo.valMin - 1}
                              </span>
                            )}
                            {hasAvaluoError && avaluo === "" && (
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                Por favor ingrese el valor del avalúo.
                              </span>
                            )}
                            </Col>
                          </Col>
                        </Row>
                      )}

                      {/*this.props.datosCotizacion.consultarPlacaHasError && (
                      <Alert color="warning">
                        <center>
                          <p>
                            {
                              this.props.datosCotizacion.datosPlaca
                                .errorDescripcion
                            }
                          </p>
                        </center>
                      </Alert>
                          )*/}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}

          {mostrarPropietario && (
            <Row>
              <Col md={12} sm={12} xs={12} className="mb-3">
                <Card className="flex-row ">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }}>
                      {" "}
                      Datos del Propietario
                    </h4>
                    <p />
                    {this.props.datosCotizacion.datosPersona.validacionesEdad.mensajeValidacionEdad !== "" &&
                        (
                        <Alert color="warning">
                          <center>
                            <p>
                              {this.props.datosCotizacion.datosPersona
                                .validacionesEdad.mensajeValidacionEdad
                                ? this.props.datosCotizacion.datosPersona
                                  .validacionesEdad.mensajeValidacionEdad
                                : `La edad del conductor ingresado debe estar entre ${this.props.datosCotizacion.datosPersona.validacionesEdad.valorMinimoEdad} y ${this.props.datosCotizacion.datosPersona.validacionesEdad.valorMaximoEdad} años.`}
                            </p>
                          </center>
                        </Alert>
                      )}
                    {this.props.datosCotizacion.consultarCedulaHasError && (
                      <Alert color="warning">
                        <center>
                          <p>{`Error en la consulta de la cédula(${cedula}). No se pudo obtener información. Por favor complete los datos manualmente`}</p>
                        </center>
                      </Alert>
                    )}
                    <Row>
                      <Col md={4} sm={12} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>
                          Propietario del Vehículo
                        </h5>
                      </Col>
                      <Col md={4} sm={12} xs={12}>
                        <div style={{ paddingLeft: "1em" }}>
                          {this.props.datosCotizacion.datosPersona.nombre === ""
                            ? this.props.datosCotizacion.datosPersona.cedula
                            : this.props.datosCotizacion.datosPersona.nombre !==
                              undefined
                              ? this.props.datosCotizacion.datosPersona.nombre +
                              " (" +
                              this.props.datosCotizacion.datosPersona.cedula +
                              ")"
                              : "No se pudo encontrar información del propietario, por favor ingrese la cédula del conductor."}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4} sm={12} xs={12} className="mb-3">
                        <h5 style={{ fontWeight: "bold" }}>
                          Cédula del conductor principal
                        </h5>
                      </Col>
                      <Col md={4} sm={12} xs={12} className="mb-3">
                        <Col md={12} sm={12} xs={12}>
                          <Textbox
                            tabIndex="1"
                            type="input"
                            value={cedula}
                            name="cedula"
                            id="cedula"
                            placeholder="Ejemplo: 0101320150"
                            classNameInput={"form-control"}
                            onChange={(cedula, e) => {
                              this.setState({ cedula: cedula.toUpperCase() });
                              //this.props.limpiarDatos();
                              //handleChangeCorreo(e)
                            }}
                            validate={validate}
                            validationCallback={(res) =>
                              //console.log(res)
                              this.setState({
                                hasCedulaError: res,
                                validate: false,
                              })
                            } // Optional.[Func].Default: none. Return the validation result.
                            onBlur={(e) => {
                              this.setState({ blur: true });
                              //console.log("BLUUUR");
                            }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                            validationOption={{
                              name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true,
                              type: 'number',
                              length: 10,
                              msgOnError: "Por favor ingrese un número de cédula  válido",
                            }}
                          />
                        </Col>
                      </Col>
                    </Row>

                    {this.props.datosCotizacion.consultarCedulaHasError && (
                      <Row>
                        <Col md={4} sm={12} xs={12} className="mb-3">
                          <h5 style={{ fontWeight: "bold" }}>
                            Nombres Completos
                          </h5>
                        </Col>
                        <Col md={4} sm={12} xs={12} className="mb-3">
                          <Col md={12} sm={12} xs={12}>
                            <Textbox
                              tabIndex="1"
                              type="input"
                              value={nombresCompletos}
                              name="nombres"
                              id="nombres"
                              placeholder="Ingresa sus nombres completos"
                              classNameInput={"form-control"}
                              onChange={(nombresCompletos, e) => {
                                this.setState({
                                  nombresCompletos: nombresCompletos,
                                });
                                //this.props.limpiarDatos();
                                //handleChangeCorreo(e)
                              }}
                              validate={validate}
                              validationCallback={(res) =>
                                //console.log(res)
                                this.setState({
                                  hasNombreError: res,
                                  validate: false,
                                })
                              } // Optional.[Func].Default: none. Return the validation result.
                              onBlur={(e) => {
                                this.setState({ blur: true });
                                //console.log("BLUUUR");
                              }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              validationOption={{
                                name: "nombres", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true,
                                msgOnError:
                                  "Por favor ingrese sus nombres completos", // Optional.[Bool].Default: true. To determin if it is a required field.
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                    )}

                    {this.props.datosCotizacion.consultarCedulaHasError && (
                      <Row>
                        <Col md={4} sm={12} xs={12} className="mb-3">
                          <h5 style={{ fontWeight: "bold" }}>
                            Fecha Nacimiento
                          </h5>
                        </Col>
                        <Col md={4} sm={12} xs={12} className="mb-3">
                          <Col md={12} sm={12} xs={12}>
                            <DatePicker
                              {...this.props}
                              dateFormat="dd/MM/yyyy"
                              isClearable={false}
                              selected={this.state.startDate}
                              onChange={this.handleChangeDate}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control"
                              ref={(node) => {
                                this.ref = node;
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                    )}

                    {this.props.datosCotizacion.consultarCedulaHasError && (
                      <Row>
                        <Col md={4} sm={12} xs={12} className="mb-3">
                          <h5 style={{ fontWeight: "bold" }}>Estado civil</h5>
                        </Col>
                        <Col md={4} sm={12} xs={12} className="mb-3">
                          <Col md={12} sm={12} xs={12}>
                            <Select1
                              tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"selectEstadoCivil"} // Optional.[String].Default: "". Input ID.
                              name={"selectEstadoCivil"} // Optional.[String].Default: "". Input name.
                              value={ecivilSeleccionado} // Optional.[String].Default: "".
                              optionList={arrayECiviles} // Required.[Array of Object(s)].Default: [].
                              onChange={(ecivilSeleccionado, e) => {
                                this.setState({ ecivilSeleccionado });
                                //console.log(e);
                              }} // Optional.[Func].Default: () => {}. Will return the value.
                              validate={validate}
                              validationCallback={(res) =>
                                //console.log(res)
                                this.setState({
                                  hasEcivilError: res,
                                  validate: false,
                                })
                              }
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "selectEstadoCivil", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError:
                                  "Por favor seleccione su estado civil",
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                    )}

                    {this.props.datosCotizacion.consultarCedulaHasError && (
                      <Row>
                        <Col md={4} sm={12} xs={12} className="mb-3">
                          <h5 style={{ fontWeight: "bold" }}>Género</h5>
                        </Col>
                        <Col md={4} sm={12} xs={12} className="mb-3">
                          <Col md={12} sm={12} xs={12}>
                            <Select1
                              tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"selectGeneros"} // Optional.[String].Default: "". Input ID.
                              name={"selectGeneros"} // Optional.[String].Default: "". Input name.
                              value={generoSeleccionado} // Optional.[String].Default: "".
                              optionList={arrayGeneros} // Required.[Array of Object(s)].Default: [].
                              onChange={(generoSeleccionado, e) => {
                                this.setState({ generoSeleccionado });
                                //console.log(e);
                              }} // Optional.[Func].Default: () => {}. Will return the value.
                              validate={validate}
                              validationCallback={(res) =>
                                //console.log(res)
                                this.setState({
                                  hasGeneroError: res,
                                  validate: false,
                                })
                              }
                              onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "selectGeneros", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione su género",
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {validacionAnioModelo && (
            <Row>
              <Col md={12} sm={12} xs={12} className="mb-3">
                <Alert
                  color="warning"
                  isOpen={this.state.visibleAlert}
                  toggle={this.onDismiss}
                >
                  <center>
                    <p>
                      {this.props.datosCotizacion.textoMsg
                        ? this.props.datosCotizacion.textoMsg
                        : ""}
                    </p>
                  </center>
                </Alert>
              </Col>
            </Row>

          )}

          <Row>
            <Col md={12} sm={12} xs={12}>
              {
                !this.props.datosCotizacion.datosPlaca
                  .mostrarMensajeRestriccion &&
                ((mostrarModelos ||
                  mostrarMarcas ||
                  mostrarPropietario ||
                  mostrarAnio ||
                  mostrarChasis ||
                  mostrarMotor ||
                  mostrarAvaluo)) && (
                  <Button
                    onClick={this.validateForm2}
                    className="btn btn-primary button-align-left"
                  >
                    <i class="fa fa-chevron-circle-right" aria-hidden="true" />
                    &nbsp;CONTINUAR
                  </Button>
                )}
              {this.props.datosCarrito.productosCarrito !== undefined &&
                this.props.datosCarrito.productosCarrito.idCarrito &&
                this.props.datosCarrito.productosCarrito.idCarrito !== null &&
                this.props.datosCarrito.productosCarrito.idCarrito !== "" &&
                editarPlacaErronea === true && (
                  <Button
                    onClick={this.regresaResumen}
                    className="btn btn-purple btn btn-secondary"
                    style={{ marginLeft: "5px" }}
                  >
                    <i class="fa fa-chevron-circle-left" aria-hidden="true" />
                    &nbsp;REGRESAR RESUMEN
                  </Button>
                )}
            </Col>
          </Row>
          <div style={{ marginTop: '2rem' }}>
            {/* Validacion de duplicidad */}
            {console.log('test dup msg', this.props.datosListaNegra)}
            {this.props.datosListaNegra.inListaNegra
              ?
              <Alert color="danger">
                <center><p>{this.props.datosListaNegra.inListaNegraMensaje}</p></center>
              </Alert>
              :
              null
            }
            {this.props.datosListaNegra.listaNegraError &&
              <Alert color="danger">
                <center><p>{ErrorMsgConstants.errorServicioListaNegra}</p></center>
              </Alert>
            }
          </div>
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  datosCotizacion: state.datosCotizacion,
  datosCarrito: state.dataProductoCarrito,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  catalogosCotizacion: state.catalogosCotizacion,
  datosPersonas: state.datosCotizacion.datosPersona,
  datosSucursales: state.datosSucursales,
  limitesVehiculos: state.dataParametros,
  sucursales: state.datosSucursales.DataSucursales,
  sucursalesStatus: state.datosSucursales,
  datosMovil: state.datosMovil,
  datosListaNegra: state.datosListaNegra,
  provinciasComparador: state.dataTerritoriosComparador.territorios.provincias,
  catalogoCotizacion: state.catalogosCotizacion,
});
const mapDispatchToProps = (dispatch) => {
  return {
    limpiarDatos: () => dispatch(limpiarDatosCotizacion()),
    limpiarCatalogos: () => dispatch(limpiarCatalogos()),
    setDatosPlaca: (datos) => dispatch(setConsultaPlaca(datos)),
    consultarCedula: (cedula, esAsegurado, esInicial) => dispatch(consultarCedulaFetch(cedula, esAsegurado, esInicial)),
    modificarCarrito: (datos) => dispatch(FetchModificarCarrito(datos)),
    setDatosPersona: (datos) => dispatch(setDatosPersona(datos)),
    listarModelos: (marca, esComparador) => dispatch(listarModelosFetch(marca, esComparador)),
    limpiarCarrito: () => dispatch(limpiarDatosCarrito()),
    limpiarDatosListaNegra: () => dispatch(LimpiarListaNegra()),
    checkInListaNegra: (identificacion, datosUsuario) => dispatch(estaEnListaNegra(identificacion, datosUsuario)),
    consultarProvincias: (ramo, sucursal) => dispatch(listarProvinciasComparadorFetch(ramo, sucursal)),
    fetchRamos: () => dispatch(ramosFetch()),
    fethSucursales: () => dispatch(sucursalesFetch()),
    updateSucursalSelecionada: (SucursalSelecionada) =>
      dispatch(updateSucursalSeleccionada(SucursalSelecionada)),
    fetchMsg: (param) => dispatch(FetchMsg(param)),
    fetchValidaModelo: (param, param2) =>
      dispatch(FetchValidarModelo(param, param2)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Cotizacion)
);
